import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import LoginPage from "../../pages/LoginPage/LoginPage";
import MainPage from "../../pages/MainPage/MainPage";
import TranslaterPage from "../../pages/TranslaterPage/TranslaterPage";
import ReportPage from "../../pages/ReportPage/ReportPage";

import './App.css';
import { ContextProvider } from "../../context/context";

const App = () => {
	return (
		<ContextProvider>
			<Router>
				<AppContent />
			</Router>
		</ContextProvider>
	);
};

const AppContent = () => {
	const [isLoggedIn, setLoggedIn] = useState(false);
	const [isAnimating, setIsAnimating] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const handleLogin = () => {
		setIsAnimating(true);
		setTimeout(() => {
			setLoggedIn(true);
			navigate('/main');
		}, 500);
	};

	// If user is logged in but on the login page, redirect to main
	useEffect(() => {
		if (isLoggedIn && location.pathname === '/') {
			navigate('/main');
		}
	}, [isLoggedIn, location.pathname, navigate]);

	return (
		<div className="app-container">
			<div className={`login-page-wrapper ${isAnimating || location.pathname !== '/' ? 'fade-out' : ''}`}>
				<LoginPage onLogin={handleLogin} />
			</div>

			<Routes>
				<Route path="/main" element={
					<div className={`main-page-wrapper ${location.pathname === '/main' ? 'zoom-in' : ''}`}>
						<MainPage />
					</div>
				} />
				<Route path="/translator" element={<TranslaterPage />} />
				<Route path="/report" element={<ReportPage />} />
				{/* A default route might be needed if you want to handle '/' when not logged in */}
				<Route path="/" element={null} /> 
			</Routes>
		</div>
	);
};

export default App;
